import Layout from "../components/Layout"
import Stack from "@mui/material/Stack"
import { useTranslation } from "react-i18next"
import { useAuth } from "../auth"
import { Box, Button, TextField, Typography } from "@mui/material"
import { PageTitle } from "../components/PageTitle"
import People from "@mui/icons-material/People"
import DialogForm from "../components/DialogForm"
import { ChangePassword } from "../types"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useSnackbarMessage } from "../hooks/snackbar"
import ChangePasswordForm from "../components/forms/ChangePasswordForm"
import { fetchApi } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { useIsMobile } from "../hooks/mobile"
import PreferenzeUtenteForm from "../components/forms/PreferenzeUtenteForm"
import { User } from "@sentry/react"

export default function Profilo() {
  const { t } = useTranslation()

  const { user, tokens, performLogout, setUser } = useAuth()
  const showMessage = useSnackbarMessage()

  const [modificaPasswordState, modificaPasswordActions] = useModalTrigger()
  const [preferenzeUtenteState, preferenzeUtenteActions] = useModalTrigger()

  const isMobile = useIsMobile()

  return (
    <Layout padding>
      <Stack sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PageTitle
            title={t("profilo.titolo_profilo")}
            breadcrumbs={[
              {
                label: t("profilo.profilo"),
                iconType: People,
              },
            ]}
          />
          <Box sx={{ display: "flex", gap: 1, flexDirection: isMobile ? "column" : "row" }}>
            {/* Button to open change password dialog */}
            <Button
              variant="contained"
              color="primary"
              sx={{ mr: isMobile ? 0 : 2 }}
              onClick={() => {
                modificaPasswordActions.open()
              }}
            >
              {t("profilo.modifica_password")}
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={() => {
                performLogout()
              }}
            >
              {t("profilo.logout")}
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 2 }} display={"flex"} flexDirection={isMobile ? "column" : "row"} gap={2}>
          {/* three input disabled 33% width */}
          <Box sx={{ width: isMobile ? "100%" : "33%", mr: isMobile ? 0 : 2 }}>
            <TextField
              variant="filled"
              label={t("user.nome")}
              value={user?.full_name}
              fullWidth
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Box>
          <Box sx={{ width: isMobile ? "100%" : "33%", mr: isMobile ? 0 : 2 }}>
            <TextField
              variant="filled"
              label={t("user.email")}
              value={user?.email}
              fullWidth
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Box>
          <Box sx={{ width: isMobile ? "100%" : "33%" }}>
            <TextField
              variant="filled"
              label={t("user.ruolo")}
              value={user?.ruolo}
              fullWidth
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Box>
        </Box>

        <Box sx={{ mt: 2 }} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant="h6" sx={{ mt: 4 }} flexGrow={0} flexShrink={0} >
            {t("profilo.preferenze_utente")}
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ mr: isMobile ? 0 : 2 }}
              onClick={() => {
                preferenzeUtenteActions.open()
              }}
            >
              {t("profilo.modifica_preferenze")}
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 2 }} display={"flex"} flexDirection={isMobile ? "column" : "row"} gap={2}>
          <Box sx={{ width: isMobile ? "100%" : "33%" }}>
            <TextField
              variant="filled"
              label={t("user.display")}
              value={user?.display || t("auto")}
              fullWidth
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Box>
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          {t("profilo.display_help")}
        </Typography>

      </Stack>
      <DialogForm<ChangePassword>
        open={modificaPasswordState.isOpen}
        handleClose={modificaPasswordActions.close}
        title={t("profilo.modifica_password")}
        FormComponent={ChangePasswordForm}
        save={async (values) => {
          await fetchApi(API_URL + "/userbase/change-password/", {
            method: "PUT",
            body: JSON.stringify(values),
            responseType: "raw",
            headers: {
              Authorization: `Bearer ${tokens?.access}`,
              "Content-Type": "application/json",
            },
          }).then(() => {
            showMessage(t("profilo.password_modificata_con_successo"), "success")
            modificaPasswordActions.close()
          })
        }}
      />
      {user && (
        <DialogForm<User>
          open={preferenzeUtenteState.isOpen}
          handleClose={preferenzeUtenteActions.close}
          title={t("profilo.preferenze_utente")}
          FormComponent={PreferenzeUtenteForm}
          item={user}
          save={async (values) => {
            await fetchApi(API_URL + "/utenti/" + user?.id + "/", {
              method: "PATCH",
              body: JSON.stringify(values),
              responseType: "raw",
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                "Content-Type": "application/json",
              },
            }).then(() => {
              showMessage(t("profilo.preferenze_salvate_con_successo"), "success")
              preferenzeUtenteActions.close()
              const nextUser = { ...user, ...values, id: user.id }
              setUser(nextUser)
            })
          }}
        />
      )}
    </Layout>
  )
}
